// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBxY-b_O0soa1SSNws7em7hP8hMXLAoW7c",
  authDomain: "cpinfo21-final-vote.firebaseapp.com",
  projectId: "cpinfo21-final-vote",
  storageBucket: "cpinfo21-final-vote.appspot.com",
  messagingSenderId: "96559521505",
  appId: "1:96559521505:web:e228902bec873a3f1521a0",
};

// Initialize Firebase
export default initializeApp(firebaseConfig);
